import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import HomeLatest from "@/pages/home/components/HomeLatest";
import HomeSidebar from "@/pages/home/components/HomeSidebar";
import SiteIntro from "@/pages/home/components/SiteIntro";
import PageContainer from "@/components/base/PageContainer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "影视影院-最新电影电视剧资源大全与影视资讯",
    "影视影院提供丰富的电影、电视剧资源和最新影视资讯，涵盖各类热门影片，满足用户多样化的观看与查询需求。",
    "影视影院,电影,电视剧,影视资源,影视资讯,电影推荐,电视剧更新"
  );

  return (
    <>
      <HeroCarousel />
      <CategoryShortcuts />

      <PageContainer className="py-8 md:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2">
            <HomeLatest />
          </div>
          <div className="lg:col-span-1">
            <HomeSidebar />
          </div>
        </div>
      </PageContainer>

      <SiteIntro />
    </>
  );
}